import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import RegisterComponent, { RegisterComponentProps } from './Register.component';
import { RootState } from 'src/reducers/RootReducer';
import Authentication from 'src/value-objects/Authentication';
import { register, RegisterAction, registerClearErrors } from 'src/actions/authentication/register/Register.actions';
import * as registerTypes from 'src/actions/authentication/register/Types';
import { Action } from 'redux';
import { OpenModal, openModal } from 'src/actions/modal';
import LoginContainer from '../login/Login.container';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

interface StateProps {
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  register: (credentials: Authentication) => Promise<RegisterAction>;
  registerClearErrors: () => RegisterAction;
  openModal: (content: JSX.Element) => void;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
}

interface State {
  name: string;
  surname: string;
  confirmPassword: string;
  termsAndConditions: boolean;
  publicity: boolean;
  password: string;
  email: string;
}
class RegisterContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.props.registerClearErrors();
    this.state = {
      name: '',
      surname: '',
      confirmPassword: '',
      termsAndConditions: false,
      publicity: false,
      password: '',
      email: '',
    };
  }

  public render(): React.ReactNode {
    return <RegisterComponent {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {
    this.props.register(this.state).then((response: Action) => {
      if (response.type === registerTypes.REGISTER_SUCCESS) {
        this.props.modalRef!.modal('hide');
        window.location.reload();
      }
    });
  }

  private login(): void {
    this.props.openModal(
      <LoginContainer/>
    );
  }

  private getComponentProps(): RegisterComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      login: () => this.login(),
      termsAndConditions: this.state.termsAndConditions,
      publicity: this.state.publicity,
      error: this.props.error,
      errorMessage: this.props.errorMessage,
      modalRef: this.props.modalRef!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    register: (credentials: Authentication): Promise<RegisterAction> => {
      return dispatch(register(credentials));
    },
    registerClearErrors: (): RegisterAction => {
      return dispatch(registerClearErrors());
    },
    openModal: (content: JSX.Element): OpenModal => {
      return dispatch(openModal(content));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  error: state.authentication.registerError,
  errorMessage: state.authentication.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/register/Register.container.tsx